import { Shield } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#0D0F14] border-t border-[#1A2332] py-12"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src="https://cdn.sanity.io/images/7m0pyiuk/production/1fe5854dacb1d96f8cdbeebcbc22a3e3dd9acc67-120x52.svg"
              alt="Big Leap"
              className="h-6 brightness-0 invert opacity-60"
            />
            <span className="text-[#00E5FF] font-bold text-sm font-mono">
              LeapForce
            </span>
          </div>
          <div className="flex items-center gap-6">
            <a href="#problem" className="text-xs text-[#475569] hover:text-[#94A3B8] transition-colors uppercase tracking-wider">
              Problem
            </a>
            <a href="#solution" className="text-xs text-[#475569] hover:text-[#94A3B8] transition-colors uppercase tracking-wider">
              Solution
            </a>
            <a href="#demo" className="text-xs text-[#475569] hover:text-[#94A3B8] transition-colors uppercase tracking-wider">
              Demo
            </a>
            <a href="#contact" className="text-xs text-[#475569] hover:text-[#94A3B8] transition-colors uppercase tracking-wider">
              Contact
            </a>
          </div>
          <div className="flex items-center gap-2 text-[10px] font-mono text-[#475569]">
            <Shield size={10} />
            <span>&copy; {new Date().getFullYear()} Big Leap LLC. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
